/* eslint-disable @typescript-eslint/no-explicit-any */

import type { OrderedDish, Topping } from "@/types/order";

interface CountedTopping extends Topping {
  count: number;
}

function countToppings(toppings: Topping[]): CountedTopping[] {
  const map = new Map<string, CountedTopping>();

  toppings?.forEach((topping) => {
    const key = topping.toppingId ?? topping.id;

    if (!map.has(key)) {
      map.set(key, { ...topping, count: 1 });
    } else {
      const existing = map.get(key)!;
      existing.count += 1;
    }
  });

  return Array.from(map.values());
}

function groupDishes(dishes: OrderedDish[]) {
  const map = new Map<string, any>();

  dishes.forEach((dish) => {
    const { id, ...rest } = dish;

    const key = JSON.stringify({
      ...rest,
      toppings: rest.toppings?.map((t) => ({
        toppingId: t.toppingId ?? t.id,
        quantity: t.quantity,
      })),
    });

    if (!map.has(key)) {
      map.set(key, {
        ...rest,
        toppings: countToppings(rest.toppings),
        count: 1,
        ids: [id],
      });
    } else {
      const existing = map.get(key);
      existing.count += 1;
      existing.ids.push(id);
    }
  });

  return Array.from(map.values());
}

export default groupDishes;
